'use client'
import { usePathname } from 'next/navigation'
import BroadstreetScript from './BroadstreetScript'

const SneakerAd = ({ lang }) => {
  const pathname = usePathname()
  if (pathname.includes('trending-article')) {
    return null
  }

  return (
    <div className="sneaker-ad">
      <BroadstreetScript zoneId="172254" />
    </div>
  )
}

export default SneakerAd
